import { CopyDesignCodeStateEnum } from '@inter-ikea-kompis/component-copy-design-code';

enum ConfirmationSummaryCopyDesignCodeStateEnum {
	default = CopyDesignCodeStateEnum.default,
	success = CopyDesignCodeStateEnum.success
}

export default ConfirmationSummaryCopyDesignCodeStateEnum;
